import { Controller } from "@hotwired/stimulus"
import { Popover } from 'bootstrap'


export default class extends Controller {
    static values = { url: String, popover: Object }

    connect() {
        this.element.dataset.action = "click->popover#show"
    }

    show(event) {
        fetch(this.urlValue).then((resp) => resp.text()).then((html) => {
            const p = new Popover(this.element, { html: true, content: html, container: "body" })
            p.show()
        })
    }
}